"use strict";
exports.__esModule = true;
exports.paramsSchema = exports.RateLimitingConfig = exports.Method = exports.Endpoint = void 0;
exports.Endpoint = 'users/request-profile-picture';
exports.Method = 'POST';
exports.RateLimitingConfig = {
    calls: 10,
    per: 1000
};
exports.paramsSchema = { "type": "object", "properties": { "userId": { "type": "string" } }, "required": ["userId"], "$schema": "http://json-schema.org/draft-07/schema#" };
